export default {
	field: 'note',
	name: 'Note',
}
